import { classed, DialogClose, DialogContent, DialogRoot, DialogViewport } from "@frend-digital/ui";
import styles from "./AlertDialog.module.css";

export const AlertDialogRoot = DialogRoot;
export const AlertDialogViewport = classed(DialogViewport, styles.viewport, {
	variants: {
		backdropBlur: {
			true: styles.backdropBlur,
		},
	},
});
export const AlertDialogContent = classed(DialogContent, styles.content);
export const AlertDialogTitle = classed.p(styles.title);
export const AlertDialogActions = classed.div(styles.actions, {
	variants: {
		justify: {
			end: styles.end,
			start: styles.start,
		},
	},
});
export const AlertDialogClose = DialogClose;
